import defaultSettings from '@/opr/settings'
import i18n from '@/opr/lang'

const title = defaultSettings.title || '巡店任务管理系统';

export default function getPageTitle(key) {
  const hasKey = i18n.te(`menu.${key}`);
  if (hasKey) {
    const pageName = i18n.t(`menu.${key}`);
    return `${pageName} - ${title}`
  }
  return `${title}`
}



// WEBPACK FOOTER //
// ./src/opr/utils/get-page-title.js